'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var subscription = exports.subscription = {
  title: 'Subscription',
  description: 'Get access to thousands of courses and Careers on all topics. With Tutors helping you to create the best learning path',
  main_cta: 'Know the plans',
  reasons_title: 'Advantages of a Subscription',
  careers_title: 'Careers',
  careers_description: 'Sign up for the Careers you want and transform your life by raising your level',
  tutors_title: 'Personal Tutors',
  tutors_description: 'You will have a Tutor willing to help you whenever you need',
  unlimited_title: 'Unlimited access',
  unlimited_description: 'You will get access to any course, of any level and topic, always',
  choose_offer_title: 'Pick a plan for your Career',
  choose_offer_description: 'Get the plan that best fits your needs. You will be able to stop or cancel it whenever you would like',
  choose_offer_legal: 'Any plan can be paid for using a credit/debit card, as well as PayPal, in multiple local currencies (EU, USD, MXN, COL, CLP, PEN); in Europe you can use direct debiting, and in Spain a deferred payment. All plans automatically renew at the end of the period, until cancelled. If you want to cancel just notify us through mail, phone, chat or any other form.',
  find_a_career: 'Find your ideal Career',
  corporate_title: 'Are you a company?',
  secondary_cta: 'Access to the plans for companies',
  monthly_catch: '',
  quarterly_catch: 'Purchasing 1 quarter',
  yearly_catch: 'Purchasing 1 year',
  monthly: 'Monthly',
  quarterly: 'Quarterly',
  yearly: 'Yearly',
  yearly_claim: 'Recommended',
  monthly_claim: '',
  quarterly_claim: '',
  full_access: 'You get access to all Careers and courses',
  unlimited_access: 'Unlimited access to all courses from web and app',
  teacher_support: 'Teacher and Tutor support',
  all_certificates: 'Certificates in all courses (free and paid)',
  payment_frequency: 'Frequency of payment',
  monthly_frequency: 'Each month',
  quarterly_frequency: 'Each 3 months',
  yearly_frequency: 'Each year',
  purchase: 'Purchase',
  period: 'month'
};


//////////////////
// WEBPACK FOOTER
// ../i18n/lib/en/subscription.js
// module id = 720
// module chunks = 0